import Salesform from "./Salesform";

import Header from "../../../../Components/Header";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";


const SalesInvoiceEdit = () => {
    const location = useLocation();
        const sales_invoice_id = location.state?.sales_invoice_id;
        
  return (
    <div className='d-flex flex-column' style={{minHeight:'100vh'}}>

      <Helmet>
				    <title>Sales Invoice - Edit</title>
			  </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <Salesform sales_invoice_id={sales_invoice_id}/>
      </div>
    </div>
  );
};

export default SalesInvoiceEdit;
